
import { dm_loaigiayto } from '../../../models/response/category/dm_loaigiayto';
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objLoaiGiayToDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as dm_loaigiayto[],
    LOAD_ERROR: "",

    LOAD_SELECT_VIEW_START: 0,
    LOAD_SELECT_VIEW_SUCCESS: [] as dm_loaigiayto[],
    LOAD_SELECT_VIEW_ERROR: "",

    LOAD_SELECT_START: 0,
    LOAD_SELECT_SUCCESS: [] as dm_loaigiayto[],
    LOAD_SELECT_ERROR: "",

    SHOW_EDIT_MODAL: {} as dm_loaigiayto | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as dm_loaigiayto,
    SAVE_SUCESS: {} as dm_loaigiayto,
    SAVE_ERROR: "",

    INSERT_START: {} as dm_loaigiayto,
    INSERT_SUCCESS: {} as dm_loaigiayto,
    INSERT_ERROR: "",

    UPDATE_START: {} as dm_loaigiayto,
    UPDATE_SUCCESS: {} as dm_loaigiayto,
    UPDATE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

};

export const eLoaiGiayToActionTypeIds = generateActionTypeIds(objLoaiGiayToDefine, "LOAI_GIAY_TO")
export type ILoaiGiayToActionTypes = IGenericActionType<typeof objLoaiGiayToDefine, "LOAI_GIAY_TO">
